// Components
import Form from 'common/components/form/new-form';
import { SideModal, SideModalButtons, SideModalInner } from 'components/modal';
// Routes
// import { choosePlan } from 'config/routes';
// Modules
import { DI } from 'modules';
import * as React from 'react';
import Agreement from './agreement/agreement';
import {
  Button,
  Hints,
  RequestPlan,
  Sftp,
  FreeAccess,
  ChoosePlan,
  Contacts,
  WorldExclusiveBtn,
} from './common';
// Constants
import { AGREEMENT_TYPE, DOWNLOAD_TYPE } from './constants';
// Hooks
import { useDownloadSlider } from './download-slider.hooks';
import { DateTime } from 'luxon';


const DownloadSlider = props => {
  const {
    currentAgreement,
    form,
    handleFormChange,
    handleFormSubmit,
    handleSftpClose,
    handleSftpSuccess,
    handleUpdateFormState,
    hints,
    isScreener,
    price,
    sftpIsOpened,
    isRepeated,
    activeAgreements,
    inactiveAgreements,
    modifyAgrList,
  } = useDownloadSlider(props);

  const {
    buttonProps,
    entity,
    innerComponent: Inner,
    innerProps,
    onClose,
    user,
    common: { strings },
    buttonText,
  } = props;

  const { payload: currentUser } = user.currentUser;
  const isRequestOnly = DateTime.fromISO(entity.published_at) <= DateTime.fromISO(process.env.REQUEST_ONLY_DATE);

  const {
    can: canDownload,
    limit_type,
    why_not_reason,
    download_type,
  } = currentAgreement?.can_download_content || {};
  const onRequest = isRequestOnly || (!canDownload && why_not_reason === 'on_request');
  const isOneOff = download_type === AGREEMENT_TYPE.ONE_OFF || !currentAgreement;

  const isExclusive = isRequestOnly || currentAgreement
    ? entity.exclusive && !isOneOff
    : entity.exclusive;
  const isPool = entity.limit_type === 'pool';
  const prefix = 'page.video.slider';
  const isFree = download_type === DOWNLOAD_TYPE.FREE;
  const worldExclusiveReq = isRequestOnly || (entity.world_exclusive && onRequest);
  const exclusiveReq = isRequestOnly || (isExclusive && onRequest);
  const noActiveAgrs = inactiveAgreements.length === modifyAgrList.length;

  return (
    <SideModal onClose={onClose}>
      {sftpIsOpened && (
        <Sftp
          company={currentUser.company}
          onClose={handleSftpClose}
          onSuccess={handleSftpSuccess}
        />
      )}

      <Form onChange={handleFormChange} onSubmit={handleFormSubmit}>
        <input name='agreement_id' type='hidden' value={form.agreement_id} />
        <input name='branding_type' type='hidden' value={form.branding_type} />

        <SideModalInner style={{ paddingBottom: 200 }}>
          {(exclusiveReq || worldExclusiveReq || noActiveAgrs) && (
            <div className='side-buy-plan'>
              <div className='side-buy-plan__text'>
                {strings[`${prefix}.world_exclusive.content_restricted_msg_1`]}

                <a className='text-button' href='mailto:cd@ruptly.tv'>
                  cd@ruptly.tv
                </a>
                {strings[`${prefix}.world_exclusive.content_restricted_msg_2`]}
              </div>
            </div>
          )}

          {user.haveUnacceptedAgreements &&
            currentUser.user_group === 'client' && (
              <div className='side-buy-plan__text'>
                {strings[`${prefix}.have_unaccepted_agreements`]}
              </div>
            )}


          {isPool && isOneOff ? (
            <div className='side-buy-plan__text'>
              {strings[`${prefix}.one_off.pool${why_not_reason === 'limit' ? '.reached' : ''}`]}
            </div>
          ) : (
            <div className='side-buy-plans'>
              {isFree && <FreeAccess />}
              {
                !((modifyAgrList.length <= 1 && entity.free_access) || exclusiveReq) && !onRequest && !noActiveAgrs &&
                modifyAgrList.map(item => (
                  <Agreement
                    key={item.id}
                    agreement={item}
                    entity={entity}
                    form={form}
                    isRepeated={isRepeated}
                    multiple={modifyAgrList.length > 1}
                    price={price}
                  />
                ))
              }
            </div>
          )}

          {
            (!isRequestOnly && ((!activeAgreements.length && !(entity.world_exclusive || exclusiveReq)) || limit_type !== 'none')) &&
            <>
              {
                isPool && isOneOff
                  ? <ChoosePlan />
                  : !exclusiveReq && <Contacts />
              }
            </>
          }

          {!isRequestOnly && canDownload && (
            <>
              {Inner && <Inner
                {...innerProps}
                agreement={currentAgreement}
                entity={entity}
                form={form}
                updateForm={handleUpdateFormState}
              />}

              {modifyAgrList.length === 1 &&
                isOneOff &&
                !entity.free_access && <ChoosePlan />}

              {modifyAgrList.length === 1 &&
                currentAgreement.agreement_type ===
                AGREEMENT_TYPE.RUPTLY_PASS && <RequestPlan />}
            </>
          )}
        </SideModalInner>

        {
          onRequest ?
            (worldExclusiveReq || isExclusive) &&
            <WorldExclusiveBtn id={entity.inner_id} onClose={props.onClose} />
            : canDownload &&
            <SideModalButtons>
              <Hints
                agreement={currentAgreement}
                hints={hints}
                isRepeated={isRepeated}
              />
              <Button
                {...buttonProps}
                agreement={currentAgreement}
                disabled={!!hints.length}
                entity={entity}
                isRepeated={isRepeated}
                price={price}
                screener={isScreener}
                user={currentUser}
              >{buttonText}</Button>
            </SideModalButtons>
        }
      </Form>
    </SideModal>
  );
};

export default DI(['user'])(DownloadSlider);
